module.exports = __webpack_public_path__ + "static/media/icon_team.012062ef.svg";